// Fire GA tracking scripts through GTM when for is submitted successfully
document.addEventListener( 'wpcf7mailsent', function( event ) {
    if ( '5' == event.detail.contactFormId ) {
        window.dataLayer.push({
            'event' : 'form_submit',
            'form_type' : 'Contact Us',
            'form_label' : 'Contact',
        });
    }
}, false );

$(function() {
    // Some jQuery stuffs here
});